import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
//import { Menu } from './menu.model';
//import { verticalMenuItems, horizontalMenuItems } from './menu';
import { DataService } from 'src/services/data.service';







@Injectable()
export class PageContentService {

    constructor(private location: Location, private dataService: DataService,
        private router: Router) { }

    getpagecontent(id: number, menuId: number, langId: number) {
        // http://192.168.0.226:10501/api/menucontentitemlist/1?menuid=5
        return this.dataService.getRecord(('/api/menucontentitemlist/' + langId + '?menuid=' + menuId));
    }
    getBreadcrumbList(menuId: number) {
        // http://192.168.0.226:10501/api/menucontentitemlist/1?menuid=5
        return this.dataService.getRecord(('/api/breadcrumbslist/' + menuId));
    }
    getAllLatestNews(langId: number) {
        return this.dataService.getRecord('/api/latestnewslist/' + langId);
    }

    getFullLatestNews(langId: number) {
        return this.dataService.getRecord('/api/latestnewscmslist/' + langId);
    }

    getLatestNews(langId: number) {
        return this.dataService.getRecord('/api/latestnewsportallist/' + langId);
    }


    getHomeFlipContent(langId: number) {
        return this.dataService.getRecord('/api/homefliplist/' + langId);
    }

    getStatisticalData() {
        return this.dataService.getRecord('/api/statisticallist');
    }

    getFulltimeTypes() {
        return this.dataService.getRecord('/api/getfullTimetype');
    }

    getFellowshipTypes() {
        return this.dataService.getRecord('/api/getfellowshipprogramtype');
    }

    getDomainSkillTypes() {
        return this.dataService.getRecord('/api/getdomainskilstype');
    }


    getAllWeeklySeminar(langId: number) {
        return this.dataService.getRecord('/api/seminar/' + langId + "/" + null);
    }


    getLatestNewcontentById(id: number, latestnewsId: number) {
        return this.dataService.getRecord(('/api/Lastestcontentitemlist/' + id + '?latestNewsId=' + latestnewsId));
    }

    getOtherProject(langId: number) {
        return this.dataService.getRecord('/api/otherprojectlist/' + langId);
    }

    getProjectContent(id: number) {
        return this.dataService.getRecord(('/api/otherproject/' + id + '?id=' + id));
    }

    getAllOurClients(langId: number, id: number, ) {
        return this.dataService.getRecord('/api/ourclient/' + langId + '?id=' + id);
    }

    getAllGosList(langId: number) {
        return this.dataService.getRecord('/api/gowebportal/' + langId);
    }

    // getRollofHonour() {
    //     return this.dataService.getRecord('/api/rollhonour');
    // }


    getRollofHonour(languageId: number, id: number) {

        return this.dataService.getRecord(('/api/rollhonour/' + languageId + '?id=' + id));
    }


    getPublicationList(langId: number) {
        return this.dataService.getRecord('/api/go/' + langId);
    }

    getAdvertisementList(langId: number) {
        return this.dataService.getRecord('/api/recentgo/' + langId);
    }

    getTenderList(langId: number) {
        return this.dataService.getRecord('/api/tender/' + langId);
    }

    getGalleryList(id: number, type: number) {
        
        return this.dataService.getRecord(('/api/gallery/filetype?' + 'id=' + id + '&fileType=' + type));
    }
    // getGalleryLists(langId: number , type: number) {
    //     return this.dataService.getRecord(('/api/gallery/filetype?' +  langId + '&fileType=' + type ));
    // }

    getGalleryLists(langId: number , type: number) {
        return this.dataService.getRecord(('/api/gallery/filetype?' +  langId + '&fileType=' + type ));
    }
    getSchemesList(langId: number) {
        return this.dataService.getRecord(('/api/scheme/' +  langId ));
    }
    getIecMaterialsList(id: number, type: number) {
        return this.dataService.getRecord(('/api/iecmaterials/filetype?' + 'id=' + id + '&fileType=' + type));
    }

    getPressReleaseList(id: number, type: number) {
        return this.dataService.getRecord(('/api/pressrelease/filetype?' + 'id=' + id + '&fileType=' + type));
    }

    imageDownload(id: number, refresh: boolean) {
        return this.dataService.getData('/api/iecmaterials/downloadimagebyid/' + id, refresh);
    }

    pressreleaseimage(id: number, refresh: boolean) {
        return this.dataService.getData('/api/pressrelease/downloadimagebyid/' + id, refresh);
    }

    memeDownload(id: number, refresh: boolean) {
        return this.dataService.getData('/api/gallery/downloadimagebyid/' + id, refresh);
    }


    //getFullLatestNews(langId: number) {
    //    return this.dataService.getRecord('/api/latestnewscmslist/' + langId);
    //}

    getGallerybyId(galleryId: any) {
        return this.dataService.getRecord(('/api/gallerybyid/' + galleryId));
    }

    getGallerybyTitle(title: any) {
        return this.dataService.getRecord(('/api/gallerybytitle/' + title));
    }

    getHomeCarouselSlides(langId: number) {
        return this.dataService.getRecord('/api/homesliderlist/' + langId);
    }
    getSiteconfig() {
        return this.dataService.getRecord('/api/siteconfig');
    }
}